/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The DrillQueryForm model module.
   * @module drill/model/DrillQueryForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DrillQueryForm</code>.
   * @alias module:drill/model/DrillQueryForm
   * @class
   * @param idList {Array.<Integer>} 
   */
  var exports = function(idList) {
    var _this = this;


    _this['idList'] = idList;
  };

  /**
   * Constructs a <code>DrillQueryForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DrillQueryForm} obj Optional instance to populate.
   * @return {module:drill/model/DrillQueryForm} The populated <code>DrillQueryForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'sessionTime')) {
        obj['sessionTime'] = ApiClient.convertToType(data['sessionTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idList')) {
        obj['idList'] = ApiClient.convertToType(data['idList'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * session时间戳
   * @member {Integer} sessionTime
   */
  exports.prototype['sessionTime'] = undefined;
  /**
   * @member {Array.<Integer>} idList
   */
  exports.prototype['idList'] = undefined;



  export default exports;
;


